'use client'
import React, {useState} from 'react'
import {cx} from '@local/utils/cx'
import {Button, Modal, SmallText, VideoOrImage} from '@local/ui/components'
import PlayIcon from '@local/assets/svgs/icon-play.svg'
import CloseIcon from '@local/assets/svgs/icon-close.svg'
import RatingIcon from '@local/assets/svgs/icon-rating.svg'

const CommunityReview = ({review, index}) => {
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const handleClose = () => setModalIsOpen(false)
	const handleOpen = () => setModalIsOpen(true)
	return (
		<>

			<article
				className={cx(
					'relative span-w-8-wide lg:span-w-2 group h-min group/btn',
				)}>
				<figure className='overflow-clip span-w-8-wide lg:span-w-2'>
					<VideoOrImage
						image={review.media.image}
						video={{...review.media.video, hasUnmuteButton: true}}
						selectedTab={review.media.selectedTab}
						width={217}
						fill={review.media.selectedTab === 'video'}
						height={index % 2 === 0 ? 217 : 312}
						desktopWidth={217}
						mobileWidth={217}
						className={cx(
							'w-full h-full object-cover aspect-square',
							index % 2 !== 0 && 'aspect-[217/312]',
							'transition-transform transform-gpu duration-700 ease-[cubic-bezier(.35,0,.19,1)]',
							'scale-110 group-hover:scale-100 group-focus-visible/btn:scale-100',
						)} />

				</figure>
				{!!review.media?.video?.youtubeEmbed &&
					<button onClick={handleOpen} className='flex items-center px-2 py-4 '>
						<PlayIcon className='w-20 h-20 mr-4' alt='Play Icon' aria-hidden />
						<p className='text-12 leading-moderate tracking-snug font-[350]'>Watch Full Story</p>
					</button>}

				<SmallText
					as='h3'
					textColor='grey-2'
					className={cx(
						'relative border-t border-grey-2/50 mt-12 mb-10 pt-6 leading-tight',
						'after:absolute after:-top-1 after:left-0',
						'after:w-full after:h-1 after:bg-grey-2',
						'after:scale-x-0 group-hover:after:scale-x-100 after:focus-within:scale-100 after:origin-left',
						'after:transition-transform after:duration-500 after:ease-expo-out after:transform-gpu',
					)}>
					{review.experienceTitle}
				</SmallText>
				<p className='text-12 leading-moderate tracking-snug font-[350] mb-12'>{review.review}</p>
				<div className='flex items-center justify-between  overflow-hidden'>
					<span className='text-12 font-medium uppercase text-grey-2'>
						{review.name}
					</span>
					<RatingIcon className='h-12  fill-grey-2' />
				</div>

			</article>
			{modalIsOpen &&
				<Modal
					isActive={modalIsOpen}
					onClickClose={handleClose}
					backdropClassName='bg-black opacity-50'
					className='h-3/4 w-3/4 top-20 bg-transparent pt-40 '>
					<Button
						onClick={handleClose} className={cx(
							'absolute top-10 right-10 text-white w-24 h-24 [&_svg]:w-full [&_svg]:h-full p-4 z-20',
						)}>

						<CloseIcon />
					</Button>
					<iframe width='100%' height='100%' src={review.media?.video?.youtubeEmbed} allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' referrerPolicy='strict-origin-when-cross-origin' allowFullScreen />
				</Modal>}
		</>
	)
}

export default CommunityReview
